import { Component } from '@angular/core';

import { RegisterService } from '../services/register.service';

import { ErrorService } from '../../shared/services/error.service';
import { LayoutService } from '../../shared/services/layout.service';

@Component({
    selector: 'login-registration-confirmation',
    templateUrl: 'registration-confirmation.component.html'
})

export class LoginRegistrationConfirmationComponent{

    vVerificationCode: string = "";

    constructor(
        private _registerService: RegisterService,
        private _errorService: ErrorService,
        private _layoutService: LayoutService
    ) {
        
    }

    ngOnInit() {
    	this._layoutService.setCurrentPage('login-registration-confirmation');
        this._registerService.resetError();
    }

    getBackEndError(){
        return this._errorService.getBackEndError();
    }

    getSuccessMessage(){
        return this._registerService.getSuccessMessage();
    }

    isDisableSubmit(){
        return this.vVerificationCode === undefined || this.vVerificationCode === '' ? true : false;
    }

    isLoading(){
        return this._registerService.isLoading();
    }

    resendCode(){
        this._registerService.resendCode();
    }

    confirmCode(){
        this._registerService.confirmCode(this.vVerificationCode);
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/login/components/registration-confirmation.component.ts